import { RAuth } from "@/pages/Auth/RAuth";

const NON_RETURNABLE_PATH_PREFIXES = ["/404", "/errors"];

export function normalizePath(path: string): string {
  let pathname = path.split("?")[0].trim();

  if (!pathname.startsWith("/")) {
    pathname = `/${pathname}`;
  }

  const trimmed = pathname.replace(/\/+$/, "");

  return trimmed || "/";
}

export function isAuthRoutePath(path: string): boolean {
  const normalizedPath = normalizePath(path);
  const authBase = normalizePath(RAuth.path);

  if (normalizedPath === authBase) return true;

  return normalizedPath.startsWith(`${authBase}/`);
}

export function isReturnableAppPath(path: string): boolean {
  const normalizedPath = normalizePath(path);

  if (!normalizedPath || normalizedPath === "/") return false;

  if (isAuthRoutePath(normalizedPath)) return false;

  return !NON_RETURNABLE_PATH_PREFIXES.some(
    (prefix) => normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`)
  );
}
